module.exports = __webpack_public_path__ + "media/images/certificate/rae-logo-cbc32c8cd76b5b96a35766347df5fadb.svg";